//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
import { has } from 'lodash'
import ptBR from '~/node_modules/vee-validate/dist/locale/pt_BR'

import { PASSWORD_RULES } from '~/mixins/passwordRules'

export default {
  inject: ['$validator'],
  data() {
    return {
      showEmailStep: true,
      isLookingUpUser: false,
      isLogingIn: false,
      payload: { user: {} }
    }
  },
  computed: {
    passwordRule() {
      return PASSWORD_RULES
    }
  },
  created() {
    if (this.$i18n.locale === 'en-US') return

    this.$validator.localize('pt_BR', {
      messages: ptBR.messages,
      attributes: {
        password: 'senha'
      }
    })
  },
  mounted() {
    if (this.$auth.loggedIn) this.goToRootPath()
    // TODO: Will be solved when redirect is implemented on .NET?
    try {
      window.$nuxt.$loading.finish()
    } catch {
      console.warn('Cannot execute $nuxt.$loading.finish()')
    }
  },
  methods: {
    ...mapMutations({
      updateLookedUpUser: 'login/updateLookedUpUser',
      setAuthConfirmationEmail: 'authConfirmation/email'
    }),
    async lookupAccount() {
      const invalidEmail = !(await this.$validator.validate('email'))

      if (invalidEmail) return

      this.isLookingUpUser = true

      await this.$coreApi
        .$get('users/lookup', {
          params: { email: this.payload.user.email }
        })
        .then(response => {
          this.updateLookedUpUser(response.data)
          this.showEmailStep = false
          this.$refs.password.focus()
        })
        .catch(error => {
          const hasNetWorkError = error.message === 'Network Error'

          if (hasNetWorkError) {
            this.$buefy.notification.open({
              message: this.$t('errors.network'),
              type: 'is-danger',
              position: 'is-top',
              duration: 8000
            })
          } else if (error.response.status === 404) {
            this.$validator.errors.add({
              field: 'email',
              msg: this.$t('pages.login.errorEmail.message')
            })
            this.$refs.email.focus()
          } else {
            this.$buefy.notification.open({
              message: this.$t('errors.internalServer'),
              type: 'is-danger',
              position: 'is-top',
              duration: 8000
            })
          }
        })
        .finally(() => {
          this.isLookingUpUser = false
        })
    },
    onFormKeydownEnter() {
      const email = this.payload.user.email

      this.showEmailStep && email ? this.lookupAccount() : this.startLogin()
    },
    async startLogin() {
      const invalidPassword = !(await this.$validator.validate('password'))

      if (invalidPassword) return

      if (!this.passwordRule.regex.test(this.payload.user.password)) {
        this.$buefy.notification.open({
          message: this.$t('pages.passwordRule.warning'),
          type: 'is-danger',
          position: 'is-top',
          role: 'alert',
          duration: 20000
        })

        this.goToForgot()
        return
      }

      this.isLogingIn = true

      await this.coreLogin()
    },
    async coreLogin() {
      await this.$auth
        .login({
          data: this.payload
        })
        .then(() => {
          this.$gtag('event', 'login', { method: 'Email/Password' })
        })
        .catch(error => {
          const hasNetWorkError = error.message === 'Network Error'

          if (hasNetWorkError) {
            this.$buefy.notification.open({
              message: this.$t('errors.network'),
              type: 'is-danger',
              position: 'is-top',
              duration: 8000
            })
          } else if (error.response.status === 422) {
            const errors = error.response.data.errors

            if (has(errors, 'email')) this.goToConfirmEmail()
            this.$validator.errors.add(this.validationErrors(errors))
          } else {
            this.$buefy.notification.open({
              message: this.$t('errors.internalServer'),
              type: 'is-danger',
              position: 'is-top',
              duration: 8000
            })
          }
        })
        .finally(() => {
          this.isLogingIn = false
        })
    },
    validationErrors(errors) {
      return Object.entries(errors).map(e => {
        return {
          field: e[0],
          msg: this.$t(`errors.${e[0]}`)
        }
      })
    },
    goToConfirmEmail() {
      this.setAuthConfirmationEmail(this.payload.user.email)
      this.$router.push(this.localePath({ name: 'auth-create-confirmation', query: { rc: true } }))
    },
    goToEmailStep() {
      this.showEmailStep = true
      this.$refs.email.focus()
      this.$validator.errors.clear()
    },
    goToRootPath() {
      this.$router.push(this.localePath('index'))
    },
    goToForgot() {
      this.$router.push(
        this.localePath({
          name: 'auth-recover'
        })
      )
    },
    goToRememberAccess() {
      this.$router.push(
        this.localePath({
          name: 'auth-remember-access'
        })
      )
    },
    goToCreateAccount() {
      this.$router.push(
        this.localePath({
          name: 'auth-create-warning'
        })
      )
    }
  }
}
